import { useTranslation } from 'react-i18next';
// material
import { enUS, esES, jaJP, koKR, zhCN } from '@mui/material/locale';

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: 'Korean',
    value: 'ko',
    systemValue: koKR,
    icon: '/static/icons/ic_flag_kr.svg'
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/static/icons/ic_flag_en.svg'
  },
  {
    label: 'Japanese',
    value: 'ja',
    systemValue: jaJP,
    icon: '/static/icons/ic_flag_en.svg'
  },
  {
    label: 'Spanish',
    value: 'es',
    systemValue: esES,
    icon: '/static/icons/ic_flag_es.svg'
  },
  {
    label: 'Chinese',
    value: 'zh',
    systemValue: zhCN,
    icon: '/static/icons/ic_flag_zh.svg'
  }
];

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[0];

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS
  };
}
